<!--
 * @Author: yyl
 * @Date: 2025-06-26 14:11:53
 * @LastEditTime: 2025-07-02 16:21:05
 * @LastEditors: yyl
 * @Description: 


 * @FilePath: /bolimao/Users/bolimao/Desktop/A-类私有云的项目/下关中学/xiaguan-schools-website/src/components/home/CardCalendar.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div>
    <div
      style="
        text-align: center;
        color: #fff;
        background-color: #00439a;
        line-height: 42px;
        margin-top: 4px;
      "
    >
      校历安排
    </div>
    <el-calendar class="calendar__inner" :range="range">
      <template slot="dateCell" slot-scope="{ data }">
        <!-- <p>
          {{ data.day.split("-").slice(2).join("-") }}
        </p> -->

        <el-popover
          v-if="showList(data.day).length > 0"
          placement="top-start"
          trigger="hover"
        >
          <div class="flex" v-for="item in showList(data.day)" :key="item.id">
            <div style="color: #0399ff; padding-right: 6px; width: 40px">
              {{ item.remind_time }}
            </div>
            <div style="white-space: pre-line">{{ item.content }}</div>
          </div>

          <p slot="reference">
            <el-badge is-dot class="item">
              {{ data.day.split("-").slice(2).join("-") }}
            </el-badge>
          </p>
        </el-popover>

        <p v-else>
          {{ data.day.split("-").slice(2).join("-") }}
        </p>
      </template>
    </el-calendar>
  </div>
</template>

<script>
import dayjs from "dayjs"

export default {
  props: {
    params: {
      type: Array,
    },
  },

  data() {
    return {
      range: [
        dayjs().startOf("month").format("YYYY-MM-DD"),
        dayjs().endOf("month").format("YYYY-MM-DD"),
      ],
    }
  },

  computed: {
    showList() {
      return (date) => {
        const arr = this.params || []
        return arr.filter((item) => item.time === date)
      }
    },
  },

  mounted() {},
}
</script>

<style lang="scss" scoped>
.calendar__inner {
  // ::v-deep .el-calendar__button-group {
  //   display: none;
  // }

  ::v-deep .el-calendar__header {
    padding-top: 11px;
  }

  ::v-deep .el-calendar__body {
    padding: 0;
  }

  ::v-deep .el-calendar-table .el-calendar-day {
    height: 48px;
    line-height: 36px;
    text-align: center;
  }
}
</style>
